module.exports = __webpack_public_path__ + "img/wz-7-2-2.e33bacfc.jpg";